import { TrophyOutlined, CalendarOutlined, ThunderboltOutlined } from '@ant-design/icons';
import './TabBar.css';

export type Tab = 'results' | 'today' | 'workouts';

interface TabBarProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
}

export function TabBar({ activeTab, onTabChange }: TabBarProps) {
  return (
    <nav className="tab-bar">
      <button
        className={`tab ${activeTab === 'results' ? 'active' : ''}`}
        onClick={() => onTabChange('results')}
      >
        <TrophyOutlined />
        <span>Results</span>
      </button>
      <button
        className={`tab ${activeTab === 'today' ? 'active' : ''}`}
        onClick={() => onTabChange('today')}
      >
        <CalendarOutlined />
        <span>Today</span>
      </button>
      <button
        className={`tab ${activeTab === 'workouts' ? 'active' : ''}`}
        onClick={() => onTabChange('workouts')}
      >
        <ThunderboltOutlined />
        <span>Workouts</span>
      </button>
    </nav>
  );
}
